module.exports = __webpack_public_path__ + "img/당산 맛집.429ab2f5.png";